/* eslint-disable no-unused-vars */
import { createAPIHandler, useOFetchRaw } from "@/plugins/ofetch";

const _CharitiesAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/charities.js").getCharitySearchPage>}  */
  getCharitySearchPage: createAPIHandler(
    ([billingId, query = undefined]) => [
      `/n/api/public/charities/${billingId}/search-page`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/charities.js").getCharityPage>}  */
  getCharityPage: createAPIHandler(
    ([urlpart, query = undefined]) => [
      `/n/api/public/charity-page/${urlpart}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/charities.js").getCharityPageMembers>}  */
  getCharityPageMembers: createAPIHandler(
    ([urlpart, query = undefined]) => [
      `/n/api/public/charity-page/${urlpart}/members`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/charities.js").getCampaignPage>}  */
  getCampaignPage: createAPIHandler(
    ([billingId, eventId, query = undefined]) => [
      `/n/api/public/charities/${billingId}/event/${eventId}/campaign`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/charities.js").getCampaignTopFundraisers>}  */
  getCampaignTopFundraisers: createAPIHandler(
    ([billingId, eventId, query = undefined]) => [
      `/n/api/public/charities/${billingId}/event/${eventId}/top-fundraisers`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/charities.js").getCampaignTopGroups>}  */
  getCampaignTopGroups: createAPIHandler(
    ([billingId, eventId, query = undefined]) => [
      `/n/api/public/charities/${billingId}/event/${eventId}/top-groups`,
      { method: "GET", query }
    ]
  ),
};
export { _CharitiesAPI as CharitiesAPI };
const _CreateFundraiserAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/create-fundraiser.js").getCharityContext>}  */
  getCharityContext: createAPIHandler(
    ([billingId, query = undefined]) => [
      `/n/api/public/charity/${billingId}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/create-fundraiser.js").searchFunnelEvents>}  */
  searchFunnelEvents: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/events`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/create-fundraiser.js").getQualificationContext>}  */
  getQualificationContext: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/qualification`,
      { method: "GET", query }
    ]
  ),
};
export { _CreateFundraiserAPI as CreateFundraiserAPI };
const _DonateAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/donate.js").getPaymentReturn>}  */
  getPaymentReturn: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/donate/return`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donate.js").handleWebhooks>}  */
  handleWebhooks: createAPIHandler(
    ([body = undefined, query = undefined]) => [
      `/n/api/public/donate/webhooks`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donate.js").handleTaxReceiptWebhook>}  */
  handleTaxReceiptWebhook: createAPIHandler(
    ([body = undefined, query = undefined]) => [
      `/n/api/public/donate/webhooks/tax-receipt`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donate.js").getPaymentReturnSummary>}  */
  getPaymentReturnSummary: createAPIHandler(
    ([transactionIdForPsp, token, query = undefined]) => [
      `/n/api/public/donate/payment-return/${transactionIdForPsp}/${token}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donate.js").updateNewsletterOptin>}  */
  updateNewsletterOptin: createAPIHandler(
    ([transactionIdForPsp, token, body = undefined, query = undefined]) => [
      `/n/api/public/donate/payment-return/${transactionIdForPsp}/${token}/newsletter-optin`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {DownloadAPI<import("../../../../backend/api/public/donate.js").downloadPaymentReturnTaxReceipt>}  */
  downloadPaymentReturnTaxReceipt: async function(transactionIdForPsp, token, query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/donate/payment-return/${transactionIdForPsp}/${token}/tax-receipt`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || "tax-receipt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
  /** @type {FetchAPI<import("../../../../backend/api/public/donate.js").getDonationForm>}  */
  getDonationForm: createAPIHandler(
    ([urlpartUrl, query = undefined]) => [
      `/n/api/public/donate/${urlpartUrl}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donate.js").createDonation>}  */
  createDonation: createAPIHandler(
    ([urlpartUrl, body = undefined, query = undefined]) => [
      `/n/api/public/donate/${urlpartUrl}`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donate.js").payDonationHandler>}  */
  payDonationHandler: createAPIHandler(
    ([urlpartUrl, body = undefined, query = undefined]) => [
      `/n/api/public/donate/${urlpartUrl}/pay`,
      { method: "POST", body, query }
    ]
  ),
};
export { _DonateAPI as DonateAPI };
const _DonationFormsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/donation-forms.js").getDirectDonationForm>}  */
  getDirectDonationForm: createAPIHandler(
    ([formId, query = undefined]) => [
      `/n/api/public/donation-forms/${formId}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donation-forms.js").createDirectDonation>}  */
  createDirectDonation: createAPIHandler(
    ([formId, body = undefined, query = undefined]) => [
      `/n/api/public/donation-forms/${formId}/donation`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donation-forms.js").getDirectDonation>}  */
  getDirectDonation: createAPIHandler(
    ([formId, token, query = undefined]) => [
      `/n/api/public/donation-forms/${formId}/donation/${token}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donation-forms.js").updateDirectDonationNewsletterOptin>}  */
  updateDirectDonationNewsletterOptin: createAPIHandler(
    ([formId, token, body = undefined, query = undefined]) => [
      `/n/api/public/donation-forms/${formId}/donation/${token}/newsletter-optin`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {DownloadAPI<import("../../../../backend/api/public/donation-forms.js").downloadDirectDonationTaxReceipt>}  */
  downloadDirectDonationTaxReceipt: async function(formId, token, query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/donation-forms/${formId}/donation/${token}/tax-receipt`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || "tax-receipt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
};
export { _DonationFormsAPI as DonationFormsAPI };
const _DonationsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/donations.js").getDonations>}  */
  getDonations: createAPIHandler(
    ([idFundraisingPage, query = undefined]) => [
      `/n/api/public/donations/${idFundraisingPage}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/donations.js").retrieveTaxReceipts>}  */
  retrieveTaxReceipts: createAPIHandler(
    ([body = undefined, query = undefined]) => [
      `/n/api/public/donations/retrieve-tax-receipts`,
      { method: "POST", body, query }
    ]
  ),
};
export { _DonationsAPI as DonationsAPI };
const _EventsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventSearchPage>}  */
  getEventSearchPage: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/n/api/public/events/${eventId}/search-page`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventCommunityPage>}  */
  getEventCommunityPage: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/n/api/public/events/${eventId}/community`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventTopFundraisers>}  */
  getEventTopFundraisers: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/n/api/public/events/${eventId}/top-fundraisers`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventTopCharities>}  */
  getEventTopCharities: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/n/api/public/events/${eventId}/top-charities`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventTopGroups>}  */
  getEventTopGroups: createAPIHandler(
    ([eventId, query = undefined]) => [
      `/n/api/public/events/${eventId}/top-groups`,
      { method: "GET", query }
    ]
  ),
};
export { _EventsAPI as EventsAPI };
const _ExternalRegistrationAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/external-registration.js").getContext>}  */
  getContext: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/external-registration/context`,
      { method: "GET", query }
    ]
  ),
};
export { _ExternalRegistrationAPI as ExternalRegistrationAPI };
const _FundraisingPagesAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/fundraising-pages.js").getFundraisingPageLayout>}  */
  getFundraisingPageLayout: createAPIHandler(
    ([urlpartUrl, query = undefined]) => [
      `/n/api/public/fundraising-pages/${urlpartUrl}/layout`,
      { method: "GET", query }
    ]
  ),
};
export { _FundraisingPagesAPI as FundraisingPagesAPI };
const _GroupsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/groups.js").getGroupPage>}  */
  getGroupPage: createAPIHandler(
    ([urlpart, query = undefined]) => [
      `/n/api/public/groups/${urlpart}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/groups.js").getGroupPageMembers>}  */
  getGroupPageMembers: createAPIHandler(
    ([urlpart, query = undefined]) => [
      `/n/api/public/groups/${urlpart}/members`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/groups.js").getGroupPageRecruitment>}  */
  getGroupPageRecruitment: createAPIHandler(
    ([urlpart, query = undefined]) => [
      `/n/api/public/groups/${urlpart}/recruitment`,
      { method: "GET", query }
    ]
  ),
};
export { _GroupsAPI as GroupsAPI };
const _SearchAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/search.js").searchFundraisers>}  */
  searchFundraisers: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/search/fundraisers`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/search.js").searchGroups>}  */
  searchGroups: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/search/groups`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/search.js").searchCharities>}  */
  searchCharities: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/search/charities`,
      { method: "GET", query }
    ]
  ),
};
export { _SearchAPI as SearchAPI };
const _SettingsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/settings.js").getSettings>}  */
  getSettings: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/settings`,
      { method: "GET", query }
    ]
  ),
};
export { _SettingsAPI as SettingsAPI };
const _ToolkitAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/toolkit.js").getToolkit>}  */
  getToolkit: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/toolkit`,
      { method: "GET", query }
    ]
  ),
};
export { _ToolkitAPI as ToolkitAPI };
const _UrlPartAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/url-part.js").getUrlPart>}  */
  getUrlPart: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/url-part`,
      { method: "GET", query }
    ]
  ),
};
export { _UrlPartAPI as UrlPartAPI };
